import React from 'react';

import Container from '../../components/Container';

const NotFound = (props) => {
  const { route } = props;
  if (route) {
    route.status = 404;
  }
  return (
    <Container>
      <h2>{'Sorry, we can’t find that page'}</h2>
    </Container>
  );
};

NotFound.propTypes = {};

NotFound.defaultProps = {};

export default NotFound;
